import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Gift } from 'lucide-react-native'
import { colors } from '@chillout/core'
import type { AvailableReward } from './useMemberStampData'

interface AvailableRewardsSectionProps {
  rewards: AvailableReward[]
}

export function AvailableRewardsSection({ rewards }: AvailableRewardsSectionProps) {
  const { t } = useTranslation()

  if (rewards.length === 0) return null

  return (
    <View className="gap-3">
      <Text className="text-base font-semibold text-primary">
        {t('stampAwarding.availableRewards.title')}
      </Text>

      {rewards.map((reward) => (
        <View
          key={reward.id}
          accessibilityLabel={t('stampAwarding.availableRewards.rewardAccessibilityLabel', { name: reward.name })}
          className="flex-row items-center gap-4"
        >
          <View
            style={{ backgroundColor: colors.accent.surface }}
            className="h-11 w-11 items-center justify-center rounded-xl"
          >
            <Gift size={20} color={colors.accent.DEFAULT} strokeWidth={1.5} />
          </View>

          <View className="flex-1">
            <Text className="text-base font-semibold text-primary">
              {reward.count > 1 ? `${reward.name} × ${reward.count}` : reward.name}
            </Text>
            <Text className="text-sm text-secondary">
              {t('stampAwarding.availableRewards.redemptionNote')}
            </Text>
          </View>

        </View>
      ))}
    </View>
  )
}
